interface HeroProps {
  onExploreClick: () => void;
}

export default function Hero({ onExploreClick }: HeroProps) {
  return (
    <section className="relative min-h-screen flex items-center justify-center px-8 pt-20">
      {/* Background gradient glow */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-[#14b8a6]/10 rounded-full blur-[120px]"></div>
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-[#e879f9]/10 rounded-full blur-[120px]"></div>
      </div>

      <div className="relative z-10 max-w-[1400px] w-full mx-auto">
        <div className="text-center space-y-8 animate-fade-in">
          <h1 className="text-[80px] md:text-[120px] font-extralight leading-[0.95] tracking-tight">
            OMAR MOHAMED
          </h1>
          <button
            onClick={onExploreClick}
            className="inline-block bg-[#ec4899] hover:bg-[#db2777] text-white px-12 py-4 text-sm font-medium tracking-wider transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap"
          >
            EXPLORE WORK
          </button>
        </div>

        {/* Scroll indicator */}
        <div className="absolute bottom-12 left-1/2 -translate-x-1/2 animate-bounce">
          <i className="ri-arrow-down-line text-[#ec4899] text-3xl"></i>
        </div>
      </div>
    </section>
  );
}
